export default "__VITE_ASSET__DP80csic__"